import { inject, Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { LANG_DICTIONARY_TOKEN } from '@constants/diConstant';

/**
 * Сервис получения текстов ошибок валидации (только для самых стандартных случаев).
 */
@Injectable()
export class ValidationErrorService {
    private readonly dictionary = inject(LANG_DICTIONARY_TOKEN);

    /** Некорректный адрес электронной почты */
    get email() {
        return { name: 'email', message: this.dictionary.incorrect_email };
    }

    /** Поле или группа полей с таким названием существует */
    get factorFieldExists() {
        return { name: 'factorFieldExists', message: this.dictionary.data_source_field_with_this_name_exists };
    }

    /** Укажите число меньше */
    get max() {
        return { name: 'max', message: this.dictionary.system_max };
    }

    /** Укажите число больше */
    get min() {
        return { name: 'min', message: this.dictionary.system_min };
    }

    /** Текущая запись не участвует в связи */
    get noCurrentRegistry() {
        return { name: 'noCurrentRegistry', message: this.dictionary.relation_contain_current_registry_entry_error };
    }

    /** Не соответствует формату ввода данных */
    get pattern() {
        return { name: 'pattern', message: this.dictionary.system_input_mask_error };
    }

    /** Некорректный шаблон */
    get regExp() {
        return { name: 'regExp', message: this.dictionary.report_invalid_template };
    }

    /** Обязательное поле */
    get required() {
        return { name: 'required', message: this.dictionary.system_required_field };
    }

    /**
     * Получить текст ошибки валидации
     */
    getErrorText(formControl: AbstractControl): string | null {
        // Обязательное поле
        if (formControl.hasError('required')) {
            return this.required.message;
        }

        // Минимальная длина поля N символов
        if (formControl.hasError('minlength')) {
            return (
                this.dictionary.system_field_min_length +
                ' ' +
                formControl.errors.minlength.requiredLength +
                ' ' +
                this.dictionary.system_field_symbols
            );
        }

        // Максимальная длина поля NN символов
        if (formControl.hasError('maxlength')) {
            return (
                this.dictionary.system_field_max_length +
                ' ' +
                formControl.errors.maxlength.requiredLength +
                ' ' +
                this.dictionary.system_field_symbols
            );
        }

        // Укажите число больше
        if (formControl.hasError('max')) {
            return this.max.message;
        }

        // Укажите число меньше
        if (formControl.hasError('min')) {
            return this.min.message;
        }

        // Не соответствует формату ввода данных
        if (formControl.hasError('pattern')) {
            return this.pattern.message;
        }

        // Некорректный адрес электронной почты
        if (formControl.hasError('email')) {
            return this.email.message;
        }

        // Некорректный шаблон
        if (formControl.hasError('regExp')) {
            return this.regExp.message;
        }

        // Поле или группа полей с таким названием существует
        if (formControl.hasError('factorFieldExists')) {
            return this.factorFieldExists.message;
        }

        // Текущая запись не участвует в связи
        if (formControl.hasError('noCurrentRegistry')) {
            return this.noCurrentRegistry.message;
        }

        // пытаемся получить готовые сообщения валидации для остальных случаев, если они заданы
        if (formControl.errors && typeof formControl.errors === 'object') {
            for (const error of Object.values(formControl.errors)) {
                if (typeof error === 'string') {
                    return error;
                }
            }
        }
    }
}
